import script from "./CompanionPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompanionPage.vue?vue&type=script&lang=ts&setup=true"

import "./CompanionPage.vue?vue&type=style&index=0&id=0c4c1210&lang=stylus&scoped=true"

import exportComponent from "/codebuild/output/src462465770/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c4c1210"]])

export default __exports__